import React, { Component, useState, useEffect, useLayoutEffect,useRef} from 'react'
import { Link, useHistory } from 'react-router-dom'
import TextField from '../component/TextField'
import VideoImageFile from '../component/VideoImageFile'
import Dropdown from '../component/Dropdown'
import DropdownMaster from '../component/DropdownMaster';

import Textarea from '../component/Textarea'
import service from '../services'

//Redux Connect
import { useSelector } from 'react-redux';
import { ActCreators } from '../redux/bindActionCretor'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import UploadForm from '../component/fpg/create/UploadForm'
// editor
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import { Editor } from 'react-draft-wysiwyg';

//import AWS from "aws-sdk";
import SimpleReactValidator from 'simple-react-validator';
import AWS from "aws-sdk";
import VideoOnlyUpload from './VideoOnlyUpload'
import PopUpCustomAll from '../component/fpg/create/popUpCustomAll'
import ImageOnlyUpload from './ImageOnlyUpload'
import HighlightsFh from './highlightsFh'
import commonImage from '../commonImage'

let sub;

function CreateHighlight() {
    const history = useHistory();
    const [apiserve, setApiserve] = useState(new service());

    // const [type, settype] = useState(["Select from Below","Stories", "News", "In The Press"])
    const [type, settype] = useState(["Select From Below","Stories","News","In The Press"])
    //     {
    //       name:"Stories",
    //       _id:"Stories"
    //     },
    //     { 
    //       name:"News",
    //       _id:"News"
    //     },
    //     { 
    //       name:"In The Press",
    //       _id:"In The Press"
    //     }
    //   ])
    const [position, setPosition] = useState(["Top", "Bottom"])
	// const [highLightFormate,sethighLightFormate]=useState(["Select from Below","Blog Post", "External link"])
    const [highLightFormate,sethighLightFormate]=useState(["Select From Below","Blog Post","External link"])
        // [
        //   {
        //     name:"Blog Post",
        //     _id:"Blog Post"
        //   },
        //   { 
        //     name:"External link",
        //     _id:"External link"
        //   }
        // ]
        // )

    const [data, setData] = useState(["manage Highlights", "featured highlights"])
    const [active, setActive] = useState(0)
    const [highLInfo, setHighLInfo] = useState({})
    const [isInThePress, setIsinThePress] = useState(false)
    const [storeType, setstoreType] = useState(false)
    const [isImage, setIsImage] = useState(true);
    const [videoPreLoader, setVideoPreLoader] = useState(false)
    const [deleteFilePopup, setDeleteFilePopup] = useState(false)
    const [imagePreloader, setImagePreloader] = useState(false)

    const [errorPopup, setErrorPopup] = useState(false);
    const [deleteImagePopup, setDeleteImagePopup] = useState(false)
    const [deleteVideoPopup, setDeleteVideoPopup] = useState(false)

    const [file, setFile] = useState(null);
    const [imgFile, setImgFile] = useState(null);
    const [urlFile, setUrlFile] = useState(null);
    const [urlImgFile, setUrlImgFile] = useState(null);
    const [errorMsg, setErrorMsg] = useState('')
    const [selectedHighligths, setselectedHighligths] = useState("Select From Below")
    const [, updateState] = React.useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);
    const validator = useRef(new SimpleReactValidator(
        {
            autoForceUpdate: this,
            validators: {
                highlightTitle: {  // name the rule
                    message: 'This Field is required.',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^[\s\t\r\n]*\S+/ig) && params.indexOf(val) === -1
                    },
                    required: true  // optional
                },
                highlightFormat: {  // name the rule
                    message: 'This Field is required.',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^[\s\t\r\n]*\S+/ig) && params.indexOf(val) === -1
                    },
                    required: true  // optional
                },
                highlightType: {  // name the rule
                    message: 'This Field is required.',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^[\s\t\r\n]*\S+/ig) && params.indexOf(val) === -1
                    },
                    required: true  // optional
                }
            }
        }
    ))    
    const [selectdata, setSelectData] = useState([{
        id: "1",
        desc: "This Is Not a Burial, It's a Resurrection",
        category: "In the Press",
        value: "inpress"
    },
    {
        id: "2",
        desc: "It's a Resurrection",
        category: "Sundance Hashtag",
        value: "hashtag"
    },
    {
        id: "3",
        desc: "Burial, It's a Resurrection",
        category: "News",
        value: "news"
    }])
    const [high,setHigh] = useState({})
    useEffect(() => {
        if (imgFile) {
            const fileList = Math.round((imgFile && imgFile.size / 1024));
            if (fileList >= 2048) {
                setErrorMsg('Please upload a file smaller than 2 MB')
                setErrorPopup(true)
                return false;
            }
            if (imgFile && imgFile.type === 'image/png' || imgFile && imgFile.type === 'image/jpg' || imgFile && imgFile.type === 'image/jpeg') {
                setTimeout(() => {
                    imageUploadOne(imgFile, urlFile);
                }, 0)
            } else {
                setErrorMsg('Please upload a file for PNG,JPG or JPEG')
                setErrorPopup(true)
            }
        }

    }, [imgFile]);
    useEffect(() => {

        if (file !== null) {
            if (file.type === 'video/mp4') {
                setIsImage(false);
                if (file) {
                    if (file.size > 100e6) {
                        setErrorMsg("Please upload a video smaller than 100 MB");
                        setErrorPopup(true);
                        return false;
                    }

                    if (file.type === "video/mp4") {
                        setTimeout(() => {
                            fileUploder(file, urlImgFile);
                        }, 1000);
                    } else {
                        setErrorMsg("Please upload only MP4 file");
                        setErrorPopup(true);
                    }
                }
            }
            else if ((file && file.type === "image/png") || (file && file.type === "image/jpg") || (file && file.type === "image/jpeg") || (file && file.type === "image/gif") || (file && file.type === "image/jfif")) {
                const fileList = Math.round(file && file.size / 1024);
                setIsImage(true);
                if (fileList >= 2048) {
                    setErrorMsg('Please upload a file smaller than 2 MB')
                    setErrorPopup(true)
                    return false;
                }
                if ((file && file.type === "image/png") || (file && file.type === "image/jpg") || (file && file.type === "image/jpeg") || (file && file.type === "image/gif") || (file && file.type === "image/jfif")) {
                    setTimeout(() => {
                        fileUploder(file, urlImgFile);
                    }, 0)
                } else {
                    setErrorMsg('Please upload a file for PNG,JPG or JPEG')
                    setErrorPopup(true)
                }
            }
        }

    }, [file])
    // useEffect(() => {
    //     const isHighLightType = () => {
    //         if (highLInfo.highLightFormate === "Blog Post") {
    //             setIsinThePress(false)
    //         } else {
                
    //             setIsinThePress(true)
    //         }
    //     }
    //     if (highLInfo) isHighLightType();
    // }, [highLInfo.highlightType])
    const addHighLight = () => {
      
        if (validator.current.allValid() && (highLInfo.highlightFormat === "Blog Post")) {
          
            let paragraph1 = highLInfo && highLInfo.paragraph1 ? draftToHtml(convertToRaw(highLInfo && highLInfo.paragraph1.getCurrentContent())) : ''
            let paragraph2 = highLInfo && highLInfo.paragraph2 ? draftToHtml(convertToRaw(highLInfo && highLInfo.paragraph2.getCurrentContent())) : ''
            let paragraph3 = highLInfo && highLInfo.paragraph3 ? draftToHtml(convertToRaw(highLInfo && highLInfo.paragraph3.getCurrentContent())) : ''
            let paragraph4 = highLInfo && highLInfo.paragraph4 ? draftToHtml(convertToRaw(highLInfo && highLInfo.paragraph4.getCurrentContent())) : ''
            const data = {
                highlightType:highLInfo.highlightType === undefined ? "Stories" : highLInfo.highlightType,
                highlightFormat:highLInfo.highlightFormat === undefined ? "Blog Post" : highLInfo.highlightFormat,
                highlightTitle: highLInfo.highlightTitle,
               featuredHighlightImagePosition: highLInfo.featuredHighlightImagePosition?highLInfo.featuredHighlightImagePosition:"Top",
                featuredHighlightCTATitle: highLInfo.featuredHighlightCTATitle,
                highlightImage1: highLInfo.highlightImage1 || '',
                highlightImage1Url: highLInfo.highlightImage1Url || '',
                mediaDescription1: highLInfo.mediaDescription1,
                paragraph1: paragraph1,
                paragraph2: paragraph2,
                quote: highLInfo.quote,
                quoteBy: highLInfo.quoteBy,
                paragraph3: paragraph3,
                highlightImage2: highLInfo.highlightImage2 || '',
                highlightImage2Url: highLInfo.highlightImage2Url || '',
                mediaDescription2: highLInfo.mediaDescription2,
                paragraph4: paragraph4,
            }
       
            apiserve.sendevent("homePage|featuredHighlight|create", data)
         
        } else if (validator.current.allValid() && highLInfo.highlightFormat === "External link") {
       
            const data = {
                highlightType:highLInfo.highlightType === undefined ? "Stories" : highLInfo.highlightType,
                highlightFormat: highLInfo.highlightFormat,
                highlightTitle: highLInfo.highlightTitle,
                highLightOpeningText: highLInfo.highLightOpeningText,
                highlightImage1Url: highLInfo.highlightImage1Url,
                mediaDescription1: highLInfo.mediaDescription1,
               
             featuredHighlightCTATitle: highLInfo.featuredHighlightCTATitle,
                highlightImage1: highLInfo.highlightImage1,
                featuredHighlightCTAUrl: highLInfo.featuredHighlightCTAUrl,
              
            }
         
            apiserve.sendevent("homePage|featuredHighlight|create", data)
         
        }else {
            
            validator.current.showMessages()
           
            forceUpdate()
        }
        
        eventCall();
    }
    const eventCall = () => {

        sub = apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "homePage|featuredHighlight|create":

                    if (!response.error) {
                        history.push('/highlights')
                    } else {
                        // this.setState({
                        //     errorPopup: true,
                        //     errorMsg: response.data.error ? response.data.error : response.data
                        // })
                    }
                    break;
            }
        })
    }

    const SelectHighlight = (e) => {
        var active = e.target.parentNode.closest(".custom_dropdown").querySelector(".select_field").classList.toggle("active");
        var panel = e.target.parentNode.closest(".custom_dropdown").querySelector(".select_content ");
        if (panel && panel.style.maxHeight) {
            panel.style.maxHeight = "";
        } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
        }
    }
    const checkedFeature = (e) => {
        let isChecked = e.target.checked;
        let value = e.target.value;
        if (isChecked) {
            setselectedHighligths(e.target.dataset.desc)
            document.querySelector(".select_content").style.maxHeight = null;
        }
    }
    //image Upload
    const handleImage = (e, id) => {
        e.stopPropagation();
        e.preventDefault();
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = (event) => {
            setImgFile(file);
            setUrlFile(event.target.result)
        };
    }

    const imageUploadOne = (file, img) => {
        setImagePreloader(true)
        var fileSet= commonImage(file,false,'',img)
         fileSet.then((value) => {
                setImagePreloader(false)
                const Info = { ...highLInfo }
                if (highLInfo.highlightFormat === "Blog Post") {
                    Info.highlightImage1 = value
                }
                else {
                    Info.highlightImage1 = value
                }
                setHighLInfo(Info)
            });
    };
    //videoUpload 
    const videoUpload = (file, img) => {
        setVideoPreLoader({ videoPreLoader: true })
        var fileSet= commonImage(file,false,'',img)
         fileSet.then((value) => {
                setVideoPreLoader(false)
                const Info = { ...highLInfo }
                Info.highlightImage2 = value
                setHighLInfo(Info)
            });
    };
    const insideOnchange = (e) => {
        const { value } = e.target
        if (highLInfo.highLightFormate === "Blog Post") {
            highLInfo.highlightImage1 = value
        }
        else {
            highLInfo.highlightImage1 = value
        }
        setHighLInfo(highLInfo)
        setDeleteImagePopup(false)
    }
    // textbox video change 
    const OnchangeVideo = (e) => {
        const { value } = e.target
        const Info = { ...highLInfo }
        Info.highlightImage2 = value
        setHighLInfo(Info)
    }

    const onDeleteImagePopup = () => {
        if (highLInfo.highlightFormat === "Blog Post") {
            highLInfo.highlightImage1 = ''
        }
        else {
            highLInfo.highlightImage1 = ''
        }
        setHighLInfo(highLInfo)
        setDeleteImagePopup(false)
    }
    const onDeleteVideoPopup = () => {
        highLInfo.highlightImage2 = ''
        setHighLInfo(highLInfo)
        setDeleteVideoPopup(false)
    }
    const closeAdminUser = () => {
       
        setDeleteVideoPopup(false)
        setDeleteImagePopup(false)
        setDeleteFilePopup(false)

    };
    //drop down handle Change 

    const dropChangeType = (e) => {
        if (e.target.value === "Select From Below") {
            e.target.value = "";
          }
        const { name, value } = e.target
        
        // if (value === "Stories" ) {
        //     setIsinThePress(false)
        //     setstoreType(true)
        // } else if(value === "News"){
        //     setIsinThePress(false)
        //     setstoreType(false)
        // }
        // else {
        //     setIsinThePress(true)
        //     setstoreType(false)
        // }
       
        setHighLInfo({
            ...highLInfo, [name] : value
        })
       
       
    }
   

    const dropChangePosition = (e) => {
        const { name, value } = e.target
        setHighLInfo({
            ...highLInfo,
            [name]: value
        })
    }

    //intput handle Change 
    const onInputChange = (e) => {
        const { name, value } = e.target
        setHighLInfo({
            ...highLInfo,
            [name]: value
        })
    }
    //editor handle Change 
    const onEditorStateChange = (e, p) => {
        setHighLInfo({
            ...highLInfo,
            [p]: e
        });
    }
    const fileUploder = (file, img) => {
        setVideoPreLoader({ videoPreLoader: true })
        var fileSet= commonImage(file,false,'',img)
         fileSet.then((value) => {
                setVideoPreLoader(false)
                const Info = { ...highLInfo }
                Info.highlightImage2 = value
                setHighLInfo(Info)
            });
    };

    const onChangeFile = (e, ref) => {
        e.stopPropagation();
        e.preventDefault();
        try {
            let file = e.target.files[0];
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onloadend = (event) => {
              setFile(file)
              setUrlImgFile(event.target.result)
            };
            if (ref) ref.current.value = "";
          } catch (error) {
          }
    };

    const insideImagechange = (e) => {
        const { value } = e.target
        if (highLInfo.highLightFormate === "Blog Post") {
            highLInfo.highlightImage1Url = value
            setHighLInfo({
                ...highLInfo,
                highlightImage1Url: value
            })
        }
        else {
            highLInfo.highlightImage1Url = value
            setHighLInfo({
                ...highLInfo,
                highlightImage1Url: value
            })
        }
        setDeleteImagePopup(false)
    }
    const insideFilechange = (e) => {
        const { value } = e.target
        highLInfo.highlightImage2Url = value
        setHighLInfo({
            ...highLInfo,
            highlightImage2Url: value
        })
        setDeleteFilePopup(false)
    }
    const onDeleteFilePopup = (e, id) => {
        setVideoPreLoader(true)
        highLInfo.highlightImage2 = ''
        setHighLInfo(highLInfo)
        setDeleteFilePopup(false)
        setTimeout(() => {
            setVideoPreLoader(false)
        }, 2000);
    }
    const image = () => {
        const { imageUrl } = apiserve;
        if (highLInfo.highlightFormat === "External link") return highLInfo.highlightImage1 ? imageUrl + highLInfo.highlightImage1 : highLInfo.highlightImage1Url
        return highLInfo.highlightImage1 ? imageUrl + highLInfo.highlightImage1 : highLInfo.highlightImage1Url
    }
    const imageUrlValue = () => {

        if (highLInfo.highlightFormat === "External link") return highLInfo.highlightImage1Url
        return highLInfo.highlightImage1Url
    }
    const showDeleteIcon = () => {
        if (highLInfo.highlightFormat === "External link") return highLInfo.highlightImage1 ? highLInfo.highlightImage1 : ''
        return highLInfo.highlightImage1 ? highLInfo.highlightImage1 : ''
    }
    const cancelFn = () =>{
		history.push('/highlights')
	}
    return (
        <>
            <div className="right_side_wrapper">
                <ul className="fpg_admin_tab disp_flex small_list_tab">
                    {
                        data && data.map((list, index) => {
                            return (
                                // <li className={active === index ? 'active' : '' }>
                                <li className={active === index ? 'active' : ''} onClick={() => setActive(index)}>
                                    <p className="uppercase text_center">
                                        <div>
                                            {list}
                                        </div>
                                    </p>
                                </li>
                            )
                        })
                    }
                </ul>
                <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
                    <Link className="back_link" to='/highlights'>
                        <svg width="5" height="10" viewBox="0 0 5 10" fill="none"> <path d="M5 0L0 5L5 10V0Z" fill="black" /> </svg>
                                Back To List
                    </Link>
                </div>
                <div className="fpg_tabcontent ticketing_content  home_content">

                    {
                        active === 0 ?
                            <div className="edit_featured">
                                <div className="featured_container">
                                    <form>
                                        <div className="field_row horizontal_field d_flex field_label">
                                            <Dropdown options={type} label="Highlight Type:" name="highlightType" onChange={(e) => dropChangeType(e)} value={highLInfo.highlightType} fpgerror={validator.current.message('highlightType', highLInfo.highlightType, 'highlightType|required')}/>

                                            <Dropdown options={highLightFormate} label="Highlight Format:" value={highLInfo.highlightFormat} name="highlightFormat" onChange={(e) => dropChangeType(e)} fpgerror={validator.current.message('highlightFormat', highLInfo.highlightFormat, 'highlightFormat|required')} />

                                          
                                        </div>
                                        <div className="field_row horizontal_field">
                                            <TextField type="text" label="Highlight Title:" name="highlightTitle" onChange={(e) => onInputChange(e)} fpgerror={validator.current.message('highlightTitle', highLInfo.highlightTitle, 'highlightTitle|required')}/>
                                           
                                            {/* <TextField type="text" label="Highlight Title:" name="highlightType" /> */}
                                        </div>
                                        {highLInfo.highlightFormat !== "External link"
                                            ? <div className="field_row horizontal_field">
                                                <Dropdown options={position} label="Featured Highlight Image Position:" name="featuredHighlightImagePosition" onChange={(e) => dropChangePosition(e)} />
                                            </div>
                                            : <div className="field_row horizontal_field">
                                                <Textarea label="Highlight Opening Text:" name="highLightOpeningText" height="64px" value={highLInfo.highLightOpeningText} onChange={(e) => onInputChange(e)} />
                                            </div>
                                        }
                                        <div className="field_row horizontal_field">
                                            <TextField type="text" label="Featured Highlight CTA Title:" name="featuredHighlightCTATitle" onChange={(e) => onInputChange(e)} />
                                        </div>
                                        <div className="d_flex ">
                                            <div className="field_row horizontal_field">
                                                <div className="field_row_inner ">
                                                    <label>Highlight Image:</label>
                                                    <div className="file_upload_400">
                                                        <div className="uploads_files">
                                                            <ImageOnlyUpload
                                                                item={highLInfo._id}
                                                                handleImage={(e) => handleImage(e)}
                                                                deleteImage={(e) => setDeleteImagePopup(true)}
                                                                iconDelete={true}
                                                                size="2"
                                                                id={highLInfo._id}
                                                                image={imageUrlValue()}
                                                                value={image()}
                                                                showDeleteIcon={showDeleteIcon()}
                                                                ImagePreLoader={imagePreloader}
                                                                insideOnchange={(e) => insideImagechange(e)}
                                                                isboth={false}
                                                            />
                                                        </div>

                                                    </div>
                                                </div>

                                            </div>
                                            <div className="field_row">
                                                <TextField type="text" label="Media Description:" name="mediaDescription1" onChange={(e) => onInputChange(e)} placeholder="Description, Credits, etc." />
                                            </div>
                                        </div>
                                        {highLInfo.highlightFormat !== "External link"
                                            ? <>
                                                <div className="field_row horizontal_field">
                                                    <div className="field_row_inner">
                                                        <label>Paragraph 1:</label>
                                                        <div className="field_input relative editor_wrapper">
                                                            {/* <div className="heading_bg"> </div> */}
                                                            <div className="bg_white">
                                                                <Editor
                                                                    wrapperClassName="sd_text_editor"
                                                                    name="paragraph1"
                                                                    editorState={highLInfo.paragraph1}
                                                                    onEditorStateChange={(e) => onEditorStateChange(e, "paragraph1")}
                                                                    toolbar={{
                                                                        blockType: {
                                                                            inDropdown: true,
                                                                            options: ['Normal', 'Blockquote'],
                                                                        },
                                                                        inline: { inDropdown: true,
                                                                            options: ['bold', 'italic', 'underline', 'strikethrough'],
                                                                        },
                                                                        list: {
                                                                            inDropdown: true,
                                                                            options: ['unordered', 'ordered'],
                                                                          },
                                                                        textAlign: { inDropdown: true },
                                                                        link: { inDropdown: true },
                                                                        history: { inDropdown: true }, 
                                                                        options: ['inline', 'blockType', 'list',  'link' ,'textAlign',], 
                                                                        
                                                                    }}
                                                                    editorStyle={{ height: '200px' }}
                                                                />
                                                                {/* <TextEditor height={250} /> */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="field_row horizontal_field">
                                                    <div className="field_row_inner">
                                                        <label>Paragraph 2:</label>
                                                        <div className="field_input relative editor_wrapper">
                                                            {/* <div className="heading_bg"> </div> */}
                                                            <div className="bg_white">
                                                                <Editor
                                                                    wrapperClassName="sd_text_editor"
                                                                    name="paragraph2"
                                                                    editorState={highLInfo.paragraph2}
                                                                    onEditorStateChange={(e) => onEditorStateChange(e, "paragraph2")}
                                                                    toolbar={{
                                                                        blockType: {
                                                                            inDropdown: true,
                                                                            options: ['Normal', 'Blockquote'],
                                                                        },
                                                                        inline: { inDropdown: true,
                                                                            options: ['bold', 'italic', 'underline', 'strikethrough'],
                                                                        },
                                                                        list: {
                                                                            inDropdown: true,
                                                                            options: ['unordered', 'ordered'],
                                                                          },
                                                                        textAlign: { inDropdown: true },
                                                                        link: { inDropdown: true },
                                                                        history: { inDropdown: true }, 
                                                                        options: ['inline', 'blockType', 'list',  'link' ,'textAlign',], 
                                                                        
                                                                    }}
                                                                    editorStyle={{ height: '200px' }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="field_row horizontal_field">
                                                    <Textarea label="Quote:" height="64px" name="quote" onChange={(e) => onInputChange(e)} />
                                                </div>
                                                <div className="field_row horizontal_field">
                                                    <TextField type="text" label="Quote By:" name="quoteBy" onChange={(e) => onInputChange(e)} />
                                                </div>
                                                <div className="field_row horizontal_field">
                                                    <div className="field_row_inner">
                                                        <label>Paragraph 3:</label>
                                                        <div className="field_input relative editor_wrapper">
                                                            {/* <div className="heading_bg"> </div> */}
                                                            <div className="bg_white">
                                                                <Editor
                                                                    wrapperClassName="sd_text_editor"
                                                                    name="paragraph3"
                                                                    editorState={highLInfo.paragraph3}
                                                                    onEditorStateChange={(e) => onEditorStateChange(e, "paragraph3")}
                                                                    toolbar={{
                                                                        blockType: {
                                                                            inDropdown: true,
                                                                            options: ['Normal', 'Blockquote'],
                                                                        },
                                                                        inline: { inDropdown: true,
                                                                            options: ['bold', 'italic', 'underline', 'strikethrough'],
                                                                        },
                                                                        list: {
                                                                            inDropdown: true,
                                                                            options: ['unordered', 'ordered'],
                                                                          },
                                                                        textAlign: { inDropdown: true },
                                                                        link: { inDropdown: true },
                                                                        history: { inDropdown: true }, 
                                                                        options: ['inline', 'blockType', 'list',  'link' ,'textAlign',], 
                                                                        
                                                                    }}
                                                                    editorStyle={{ height: '200px' }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="d_flex ">
                                                    <div className="field_row horizontal_field">
                                                        <div className="field_row_inner">
                                                            <label></label>
                                                            <div className="file_upload_400">

                                                                <div className="uploads_files">
                                                                {isImage ?
                                                                    <>
                                                                            <VideoImageFile
                                                                                item={highLInfo._id}
                                                                                handleImage={(e) => onChangeFile(e)}
                                                                                iconDelete={true}
                                                                                size="2"
                                                                                id={highLInfo._id}
                                                                                image={highLInfo.highlightImage2Url}
                                                                                showDeleteIcon={highLInfo.highlightImage2}
                                                                                value={highLInfo.highlightImage2 ? apiserve.imageUrl + highLInfo.highlightImage2 : highLInfo.highlightImage2Url}
                                                                                insideOnchange={(e) => insideFilechange(e)}
                                                                                videoPreLoader={videoPreLoader}
                                                                                deleteImage={(e) => setDeleteFilePopup(true)}
                                                                                isboth={true} />
                                                                    </>
                                                                    : <VideoOnlyUpload
                                                                    handleVideo={(e,ref) => onChangeFile(e, ref)}
                                                                    url={highLInfo.highlightImage2 ? `${apiserve.imageUrl}${highLInfo.highlightImage2}` : highLInfo.highlightImage2Url}
                                                                    video={highLInfo.highlightImage2 ?`${apiserve.imageUrl}${highLInfo.highlightImage2}` : highLInfo.highlightImage2Url}
                                                                    videoUrl={highLInfo.highlightImage2Url}
                                                                    insideOnchange={(e) => insideFilechange(e)}
                                                                    item={highLInfo}
                                                                    iconDelete={true}
                                                                    showDeleteIcon={highLInfo.highlightImage2}
                                                                    videoPreLoader={videoPreLoader}
                                                                    setErrorMsg={setErrorMsg} setErrorPopup={setErrorPopup}
                                                                    deleteVideo={() => setDeleteFilePopup(true)}
                                                                    />
                                                                }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="field_row">
                                                        <TextField type="text" name="mediaDescription2" label="Media Description:" placeholder="Description, Credits, etc." onChange={(e) => onInputChange(e)} />
                                                    </div>
                                                </div>
                                                <div className="field_row horizontal_field">
                                                    <div className="field_row_inner">
                                                        <label>Paragraph 4:</label>
                                                        <div className="field_input relative editor_wrapper">
                                                            {/* <div className="heading_bg"> </div> */}
                                                            <div className="bg_white">
                                                                <Editor
                                                                    wrapperClassName="sd_text_editor"
                                                                    name="paragraph4"
                                                                    editorState={highLInfo.paragraph4}
                                                                    onEditorStateChange={(e) => onEditorStateChange(e, "paragraph4")}
                                                                    toolbar={{
                                                                        blockType: {
                                                                            inDropdown: true,
                                                                            options: ['Normal', 'Blockquote'],
                                                                        },
                                                                        inline: { inDropdown: true,
                                                                            options: ['bold', 'italic', 'underline', 'strikethrough'],
                                                                        },
                                                                        list: {
                                                                            inDropdown: true,
                                                                            options: ['unordered', 'ordered'],
                                                                          },
                                                                        textAlign: { inDropdown: true },
                                                                        link: { inDropdown: true },
                                                                        history: { inDropdown: true }, 
                                                                        options: ['inline', 'blockType', 'list',  'link' ,'textAlign',], 
                                                                        
                                                                    }}
                                                                    editorStyle={{ height: '200px' }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                            : <div className="field_row horizontal_field">
                                                <TextField type="text" label="Highlight CTA URL:" name="featuredHighlightCTAUrl"  onChange={(e) => onInputChange(e)} />
                                            </div>}
                                        <div className="text_center field_row w_100 buttons_outer">
                                            <button className="uppercase" type="button" onClick={() => cancelFn()}>CANCEL</button>
                                            <button className="uppercase active" type="button" onClick={() => addHighLight(highLInfo._id)}>SAVE</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            : ''
                    }
                    {active === 1 &&
                        <HighlightsFh />
                    }
                </div>
                {deleteFilePopup
                    ? <PopUpCustomAll
                        HeaderName="Delete video?"
                        insideDetails="Are You Sure ?"
                        insideData="Are you sure you want to delete this video or image?"
                        popupState={() => closeAdminUser()}
                        yesPopUp={() => onDeleteFilePopup()} />
                    : ""
                }
                {deleteImagePopup
                    ? <PopUpCustomAll
                        HeaderName="Delete Image?"
                        insideDetails="Are You Sure ?"
                        insideData="You want to delete this image"
                        popupState={() => closeAdminUser()}
                        yesPopUp={() => onDeleteImagePopup()} />
                    : ""
                }
            </div>
        </>
    )
}
export default (CreateHighlight)
